






























































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  PendingPersonalContribution, PendingPersonalContributionPutAction
} from "@/shared/types";

import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePendingPersonalContributionStore } from "@/admin/store/pendingPersonalContribution";

@Component({})
export default class Edit extends Vue {
  formatCurrency = formatCurrency;
  formatDateString = formatDateString;

  notifierStore = useNotifierStore();
  personalContributionStore = usePendingPersonalContributionStore();

  @Prop() pendingContribution: PendingPersonalContribution;

  statusRelease = PendingPersonalContributionPutAction.Release;
  statusHold = PendingPersonalContributionPutAction.Hold;
  statusDelete = PendingPersonalContributionPutAction.Delete;

  note = "";
  originalNote = "";
  action = PendingPersonalContributionPutAction.Release;
  originalAction = "";
  noteLimit = 250;
  isSaving = false;
  isDeleted = false;

  created (): void {
    this.onPendingContributionChanged(this.pendingContribution);
  }

  @Watch("pendingContribution", { deep: true })
  onPendingContributionChanged (pc: PendingPersonalContribution) {
    this.note = pc.note;
    this.action = pc.isOnHold ?
        PendingPersonalContributionPutAction.Hold
        : pc.isDeleted ?
          PendingPersonalContributionPutAction.Delete
        : PendingPersonalContributionPutAction.Release;

    this.originalAction = this.action;
    this.originalNote = pc.note;
    this.isDeleted = pc.isDeleted;
  }

  get currentAction () {
    return this.action;
  }

  get noteLabel () {
    return `Note (${this.noteLimit - this.note.length} characters remaining)`;
  }

  get statusHelpMessage () {
    const fromToHelpMessage = {
      [PendingPersonalContributionPutAction.Hold]: "Place record on hold",
      [PendingPersonalContributionPutAction.Delete]: "Permanently remove the record",
      [PendingPersonalContributionPutAction.Release]: "Release from hold, allow record to be processed"
    };

    if (this.action === this.originalAction) {
      return "No status change proposed.";
    }

    return fromToHelpMessage[this.action];
  }

  get submitValidation () {
    if (this.isSaving) {
      return "Saving in progress";
    }

    if (this.note.length > this.noteLimit) {
      return "Note too long";
    }

    if ((this.note === this.originalNote) &&
        (this.originalAction === this.action)) {
          return "No changes to save";
    }

    return false;
  }

  get submitTitle () {
    const message = this.submitValidation;
    if (message) {
      return message;
    }
    return "Save changes";
  }

  get isSubmitEnabled () {
    return !this.submitValidation;
  }

  get canChangeRecord () {
    return !this.isDeleted;
  }

  onCancelClick () {
    this.$router.go(-1);
  }

  onFormSubmit () {
    if (this.isSubmitEnabled) {
       this.isSaving = true;
       this.personalContributionStore.updatePendingItem({
         pendingPersonalContributionId: this.pendingContribution.pendingPersonalContributionId,
         note: this.note,
         action: this.action
        })
        .then(() => { this.notifierStore.setSuccess("Save complete"); })
        .finally(() => { this.isSaving = false; });
    }
  }
}
